/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { subscriptionCardsInput } from '../../../dataActions/DataActionExtension.g';
import { IrsmSubscriptionCardsResponse } from '../../../dataActions/DataServiceEntities.g';

/**
 * GetSubscriptions Input Action
 */
export class GetSubscriptionCardsInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;
    constructor(input: IDataServiceRequest) {
        this.input = input;
    }

    public shouldCacheOutput = () => false;

    public getCacheKey = () => `IGetSubscriptionCardsInput`;
    public getCacheObjectType = () => 'IGetSubscriptionCardsInput';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetSubscriptionCardsData extends IrsmSubscriptionCardsResponse { }

export interface IInputRequirements {
    customerId: string;
}

export const createGetSubscriptionsInput = (args: Msdyn365.ICreateActionContext, input: IInputRequirements): GetSubscriptionCardsInput => {
    const accNumber = args.requestContext.user.customerAccountNumber || input.customerId;
    return new GetSubscriptionCardsInput(
        subscriptionCardsInput(String(accNumber))
    );
};
async function getSubscriptionsAction(input: GetSubscriptionCardsInput, ctx: Msdyn365.IActionContext): Promise<IGetSubscriptionCardsData> {
    return input.input.execute(ctx);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetSubscriptionCardsData>>getSubscriptionsAction,
    input: createGetSubscriptionsInput
});
